


























import {
  defineComponent,
  ref,
  useFetch,
} from '@nuxtjs/composition-api';
import { useCache, CacheTagPrefix } from '@vue-storefront/cache';
import Notification from '~/components/Notification.vue';
import EvidenceProducts from '~/components/solepro/EvidenceProducts.vue';
import Highlights from '~/components/solepro/Highlights.vue';
import TopicHighlights from '~/components/solepro/TopicHighlights.vue';
import HTMLContent from '~/components/solepro/HTMLContent.vue';
import ProductHighlights from '~/components/solepro/ProductHighlights.vue';
import PromoBanner from '~/components/solepro/PromoBanner.vue';
import PageLoading from '~/components/GlobalComponents/PageLoading.vue';
import { CmsBlock, useContent, useHome } from "~/composables";
import { pageView } from '~/helpers/trackings/24orepro/home';
import ClientOnly from 'vue-client-only';

export default defineComponent({
  name: 'PageResolver',
  components: {
    Notification,
    HTMLContent,
    Highlights,
    TopicHighlights,
    ProductHighlights,
    PromoBanner,
    PageLoading,
    EvidenceProducts,
    ClientOnly
  },
  setup() {
    const { loadBlocks } = useContent();
    const { addTags } = useCache();
    const { heroRendered, homeLoading } = useHome();
    const home_slider = ref<CmsBlock | null>(null);
    const promo_banner = ref<CmsBlock | null>(null);
    const news_banner = ref<CmsBlock | null>(null);

    const trackPageView = async () => {
      pageView();
    };

    useFetch(async () => {
      homeLoading();
      const [cmsHomeSlider, cmsPromoBanner, cmsNewsBanner] = await Promise.all([
        loadBlocks({ identifiers: ["home_slider"] }),
        loadBlocks({ identifiers: ["home_promo_banner"] }),
        loadBlocks({ identifiers: ["home_news_banner"] }),
      ]);
      
      home_slider.value = cmsHomeSlider[0];
      promo_banner.value = cmsPromoBanner[0];
      news_banner.value = cmsNewsBanner[0];
      
      addTags([{ prefix: CacheTagPrefix.View, value: 'home' }]);

      await trackPageView();
    });

    return {
      heroRendered,
      home_slider,
      promo_banner,
      news_banner
    };
  },

});
